import Registry from "./Registry";

export default class Popup {

    static get(selector) {

        var instance = Registry.get('Popup', selector);
        if (instance)
            return instance;

        instance = new Popup(selector);
        Registry.set('Popup', selector, instance);

        return instance;

    }

    constructor(selector) {

        this.selector = selector;

        if (typeof selector === 'string')
            this.popup = $(this.selector);
        else
            this.popup = this.selector;


        this.defaults = {
            title: this.popup.find('.title h2').length ? this.popup.find('.title h2').text() : 'Заполните заявку на обратную связь',
            button: 'Отправить',
            animationTime: 250,
            success: 'Ваша заявка принята!',
            error: 'Извините, произошла ошибка. Повторите позднее.'
        };

        return this;

    }

    setValues(btn) {

        let title = btn ? (btn.attr('popup-title') ? btn.attr('popup-title') : this.defaults.title) : this.defaults.title,
            text = btn ? (btn.attr('popup-button') ? btn.attr('popup-button') : this.defaults.button) : this.defaults.button,
            salon = btn ? (btn.attr('popup-salon_id') ? btn.attr('popup-salon_id') : '') : '',
            action = btn ? btn.attr('popup-action') : '';

        this.popup.find('.title h2').text(title);
        this.popup.find('[type="submit"]').text(text);
        if (action) this.changeAction(action);

        // this.changeAction(action);
        this.changeTitle(title);
        if (btn) this.changeHiddenValues(btn);
    }

    changeAction(action) {

        if (!this.popup.find('[name="action"]').length)
            this.popup.find('form').append('<input type="hidden" name="action">');

        this.popup.find('[name="action"]').val(action);

    }

    removeHiddenInputs() {
        this.popup.find('.added[type="hidden"]').remove();
    }

    changeHiddenValues(button) {

        for (var i = 0; i < button[0].attributes.length; i++) {

            const key = button[0].attributes[i].nodeName;
            const val = button[0].attributes[i].nodeValue;

            if (key.indexOf('popup-') === 0) this.changeHiddenValue(key.slice(6), val);

        }
    }

    changeHiddenValue(name, val) {

        const hidden = this.popup.find('[name="' + name + '"]');

        if (!hidden.length)
            this.popup.find('form').prepend('<input type="hidden" class="added" name="' + name + '" value="' + val + '" >');
        else
            this.popup.find('[name="' + name + '"]').val(val);

    }

    changeTitle(title) {

        if (!this.popup.find('[name="title"]').length)
            this.popup.find('form').append('<input type="hidden" name="title">');

        this.popup.find('[name="title"]').val(title);

    }

    show(button) {

        clearTimeout(this.timeout);
        this.setValues(button);
        this.popup.addClass('popup_active');
        $('html').addClass('no-scroll');

    }

    close() {
        const self = this;
        self.popup.removeClass('popup_active');
        $('html').removeClass('no-scroll');

        this.removeHiddenInputs();
        self.popup.trigger('popup-close');
        self.timeout = setTimeout(function () {
            self.setValues(null);
        }, self.defaults.animationTime);

    }

    static message(text, type) {
        var popup = Popup.get($('#popup-message'));
        type = type ? type : 'success';
        $('#popup-message').find('.popup__text').html(text ? text : popup.defaults[type]);
        popup.show();
    }

}